var styleDataHash = "604033c4";
const injectCss = () => {
  var css = `.glob_fontElementMap,.h14CA{font-family:var(--ricos-font-family,unset)}.Ykfe5{color:var(--ricos-settings-text-color,#000);width:100%}[dir] .Ykfe5{background-color:#fff}@supports not (contain:inline-size){@media only screen and (max-width:640px){.Ykfe5{height:47px}}}@container (width < 640px){.Ykfe5{height:47px}}.Ykfe5 ._4Q84N{align-items:center;display:grid;grid-auto-columns:max-content auto max-content;grid-auto-flow:column;height:40px;width:100%;grid-gap:12px}[dir=ltr] .Ykfe5 ._4Q84N,[dir=rtl] .Ykfe5 ._4Q84N{padding-left:20px;padding-right:20px}.Ykfe5 ._4Q84N .wMCET{align-self:left}.Ykfe5 ._4Q84N ._27GIj{display:grid;grid-auto-flow:row}.Ykfe5 ._4Q84N ._27GIj .p5j6e{font-size:14px}.Ykfe5 ._4Q84N ._27GIj ._6glK8{color:#646464;font-size:12px}.Ykfe5 ._4Q84N .nljen{align-self:right}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_toggle_default = {
  "fontElementMap": "h14CA",
  "container": "Ykfe5",
  "content": "_4Q84N",
  "prefix": "wMCET",
  "titleWrapper": "_27GIj",
  "title": "p5j6e",
  "subtitle": "_6glK8",
  "suffix": "nljen"
};
export {
  list_item_toggle_default as default,
  injectCss
};
//# sourceMappingURL=list-item-toggle-scss.js.map
